const BLOCKED_ELEMENTS = "script,iframe,object,embed,link,meta,base";

export function sanitizeTourMarkup(element) {
  if (!element?.cloneNode) return "";
  const clone = element.cloneNode(true);
  clone.querySelectorAll?.(BLOCKED_ELEMENTS).forEach((node) => node.remove());
  [clone, ...(clone.querySelectorAll?.("*") || [])].forEach((node) => {
    Array.from(node.attributes || []).forEach((attribute) => {
      const name = attribute.name.toLowerCase();
      const value = String(attribute.value || "").trim().toLowerCase();
      if (name.startsWith("on") || name === "srcdoc") node.removeAttribute(attribute.name);
      if ((name === "href" || name === "src" || name === "xlink:href") && value.startsWith("javascript:")) {
        node.removeAttribute(attribute.name);
      }
    });
  });
  return clone.outerHTML;
}
